import React, { useState } from "react";
import Userdetailsmain from "./Userdetailsmain";
import Personaldetails from "./Personaldetails";
import Jobdetails from "./Jobdetails";
import Leave from "./Leave.jsx";
import Attendances from "./Attendances.jsx";
import Document from "./Document.jsx"
import Finance from "./Finance.jsx"
import Expenses from "./Expenses.jsx"
import Performance from "./Performance.jsx"
import Dashboardnavbarcopy from "../../layout/Dashboardnavbarcopy.jsx";
import MyClockins from "./Clockin.jsx";
import { EmployeeAssets } from "./Assettable.jsx";
import usePermission from "../../config/permissions.js";
import { useNavigate, useLocation } from "react-router-dom";
import { EmployeeDynamicRequestsTab, EmployeeHistoryTab, EmployeePerformanceTab } from "../EmployeeManagement/EmployeeManagementDisplay.jsx";
import { InvestmentDeclarationFormTable } from "../InvestementDeclaration/InvestmentDeclarationTables.jsx";


const UserDetails = () => {

  const location = useLocation();
  const toggleuser = location.state !== null ? location.state?.toggleuser : 1;
  const toggleexpense = location.state !== null ? location.state?.toggleexpense : 0;
  const { PERMISSION_HR_ADMIN, SUPER_ADMIN, PORTAL_SETTINGS } = usePermission();
  const [toggleState, setToggleState] = useState(toggleuser);

  const email = sessionStorage.getItem("email")

  const emp_code = sessionStorage.getItem("emp_code")

  const isSpaceCreattors = () => {
    const company = sessionStorage.getItem("company");
    return company === "Space Creattors" || company === "Space Creattors Heights";
  };

  const tabConfig = [
    { id: 1, label: "Overview" },
    { id: 5, label: "Documents" },
    { id: 4, label: "Attendance" },
    { id: 3, label: "Requests" },
    { id: 7, label: "Finance", show: SUPER_ADMIN || PORTAL_SETTINGS?.salary_slip_visible },
    { id: 8, label: "Investments" },
    { id: 9, label: "Expenses" },
    { id: 6, label: "Assets" },
    { id: 10, label: "Performance" },
    { id: 12, label: "History Logs" }, // Renamed from "Request Management" to match image

    { id: 0, label: "ClockIns", show: isSpaceCreattors() }
  ];

  const getSelectedTitle = () => {
    switch (toggleState) {
      case 0:
        return 'Clock Ins';
      case 1:
        return 'About';
      case 2:
        return 'Job';
      case 3:
        return 'Requests';
      case 4:
        return 'Attendence';
      case 5:
        return 'Documents';
      case 6:
        return 'Assets';
      case 7:
        return 'Finances';
      case 8:
        return 'Investment Form';
      case 9:
        return 'Expenses';
      case 10:
        return 'Performance';
      case 11:
        return 'History Logs';

      default:
        return 'About';
    }
  };

  return (
    <div>
      <Dashboardnavbarcopy name={getSelectedTitle()} url="Profile" />
      <div style={{ background: "#F7F8FA" }}>

        <Userdetailsmain email={email} emp_code={emp_code} />

        {/* <div className="bloc-tabss wfm-marginn">
          <button
            className={
              toggleState === 1
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(1)}
          >
            About
          </button>
          <button
            className={
              toggleState === 5
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(5)}
          >
            Documents
          </button>
          {sessionStorage.getItem("company") === "Space Creattors" ||
            sessionStorage.getItem("company") ===
            "Space Creattors Heights" ? (
            <button
              className={
                toggleState === 0
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
              }
              onClick={() => setToggleState(0)}
            >
              ClockIns
            </button>
          ) : (
            ""
          )}
          <button
            className={
              toggleState === 4
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(4)}
          >
            Attendance
          </button>

          <button
            className={
              toggleState === 3
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(3)}
          >
            Requests
          </button>

          {SUPER_ADMIN || PORTAL_SETTINGS?.salary_slip_visible ?
            <button
              className={
                toggleState === 7
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
              }
              onClick={() => setToggleState(7)}
            >
              Finance
            </button>
            : null
          }
          <button
            className={
              toggleState === 8
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(8)}
          >
            Investments
          </button>

          <button
            className={
              toggleState === 9
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(9)}
          >
            Expenses
          </button>

          <button
            className={
              toggleState === 6
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(6)}
          >
            Assets
          </button>
          <button
            className={
              toggleState === 10
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(10)}
          >
            Performance
          </button>
          <button
            className={
              toggleState === 11
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(11)}
          >
            History Logs
          </button>
          <button
            className={
              toggleState === 12
                ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
            }
            onClick={() => setToggleState(12)}
          >
            Request Management
          </button>
        </div> */}

        <div className="modern-tab-bar">
          {tabConfig.map((tab) => {
            // Check if tab has a condition (like Finance), default to true
            if (tab.show === false) return null;

            return (
              <button
                key={tab.id}
                className={`modern-tab-btn ${toggleState === tab.id ? "active" : ""}`}
                onClick={() => setToggleState(tab.id)}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="content-tabss">
          {toggleState === 1 ? <Personaldetails email={email} emp_code={emp_code} /> : null}
          {toggleState === 3 ? <Leave email={email} emp_code={emp_code} /> : null}
          {toggleState === 4 ? <Attendances email={email} emp_code={emp_code} /> : null}
          {toggleState === 0 ? <MyClockins email={email} emp_code={emp_code} /> : null}
          {toggleState === 5 ? <Document email={email} emp_code={emp_code} /> : null}
          {toggleState === 6 ? <EmployeeAssets email={email} emp_code={emp_code} /> : null}
          {toggleState === 7 ? <Finance email={email} emp_code={emp_code} /> : null}
          {toggleState === 8 ? <InvestmentDeclarationFormTable email={email} emp_code={emp_code} viewAccess={'employee'} /> : null}
          {toggleState === 9 ? <Expenses email={email} emp_code={emp_code} toggleexpense={toggleexpense} /> : null}
          {toggleState === 10 ? <EmployeePerformanceTab email={email} emp_code={emp_code} /> : null}
          {toggleState === 11 ? <EmployeeHistoryTab email={email} emp_code={emp_code} /> : null}
          {toggleState === 12 ? <EmployeeDynamicRequestsTab email={email} emp_code={emp_code} /> : null}

        </div>
      </div>
    </div>
  );
};

export default UserDetails;